module.exports = __webpack_public_path__ + "static/media/live_stream.a4bf22b9.svg";